import { InfoCircleOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import STTypo from 'core/shared/typo';
import { TypeOptions } from 'core/shared/typo/typo.models';
import { useTranslation } from 'react-i18next';
import { HighRiskLabel, InfoContainer, LowRiskLabel, MediumRiskLabel, NoRiskLabel } from './inoculum-info.styles';

export const InoculumInfo = () => {
  const { t } = useTranslation();

  return (
    <InfoContainer>
      <Flex vertical gap={24}>
        <section>
          <p>
            <STTypo type={TypeOptions.P1}>{t('pages.regional_overview.inoculum_survival.info_modal.description_1')}</STTypo>
          </p>
          <p>
            <STTypo type={TypeOptions.P1}>{t('pages.regional_overview.inoculum_survival.info_modal.description_2')}</STTypo>
          </p>
          <p>
            <STTypo type={TypeOptions.P1}>{t('pages.regional_overview.inoculum_survival.info_modal.description_3')}</STTypo>
          </p>
        </section>

        <section>
          <div style={{ marginTop: 4 }}>
            <STTypo type={TypeOptions.P1} italic>
              {t('pages.regional_overview.inoculum_survival.info_modal.risk_levels_subtitle')}
            </STTypo>
          </div>

          <Flex style={{ marginTop: 12 }}>
            <NoRiskLabel>{t(`pages.regional_overview.regional_risk.level_risk.no_risk`)}</NoRiskLabel>
            <LowRiskLabel>{t(`pages.regional_overview.regional_risk.level_risk.low_risk`)}</LowRiskLabel>
            <MediumRiskLabel>{t(`pages.regional_overview.regional_risk.level_risk.medium_risk`)}</MediumRiskLabel>
            <HighRiskLabel>{t(`pages.regional_overview.regional_risk.level_risk.high_risk`)}</HighRiskLabel>
          </Flex>
        </section>

        <section>
          <Flex align='center' gap={8}>
            <InfoCircleOutlined style={{ color: '#14803C', fontSize: 24 }} />
            <STTypo type={TypeOptions.P1} fontWeight={500}>
              {t('pages.regional_overview.inoculum_survival.info_modal.how_to_interpret')}
            </STTypo>
          </Flex>
          <div style={{ marginTop: 8 }}>
            <STTypo type={TypeOptions.P1}>{t('pages.regional_overview.inoculum_survival.info_modal.interpretation_description')}</STTypo>
          </div>
        </section>
      </Flex>
    </InfoContainer>
  );
};
